import { Component, OnInit ,ViewEncapsulation, ViewChild, ElementRef, Renderer2, Inject, NgZone, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Http, RequestOptions, Headers } from "@angular/http";
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from '../../shared-data.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { DOCUMENT } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Component({
   selector: 'ms-loginone-session',
   templateUrl:'./loginone-component.html',
   styleUrls: ['./loginone-component.scss'],
   providers: [HttpClient],
   encapsulation: ViewEncapsulation.None,
})

@Injectable()
export class LoginoneComponent implements OnInit {

  showLoadingBar() {
    this.loadingBarService.start();
  }

  hideLoadingBar() {
    this.loadingBarService.complete();
  }

  @ViewChild('username') usernameElement:ElementRef;
  @ViewChild('password') passwordElement:ElementRef;
  @ViewChild('on') onElement:ElementRef;
  @ViewChild('off') offElement:ElementRef;
  @ViewChild('backg') backElement:ElementRef;
  @ViewChild('errorMessageParent') errorMessageParentElement:ElementRef;
  @ViewChild('errorMessage') errorMessage:ElementRef;
  @ViewChild('loginWrapper') loginWrapper:ElementRef;
  @ViewChild('selectSchoolFromMultiple') selectSchoolFromMultiple:ElementRef;
  @ViewChild('goBack') goBackElement:ElementRef;

  cannotSignInOtherwise:boolean;
  constructor(
    private router: Router,
    private http: Http,
    private httpClient: HttpClient,
    private ngZone: NgZone,
    private location: Location,
    public sharedDataService: SharedDataService,
    private _Activatedroute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document
  ) { 
  }

  @ViewChild('resetRef') forReset: ElementRef;
  @ViewChild('cloze') forClose: ElementRef;

  triggerReset() {
    
    if (this.forReset) {
      let el: HTMLElement = this.forReset.nativeElement;
      el.click();
    }
    
    // this.sharedDataService.celebrate('reset triggered');
  }

  edAnaSchoolID;
  edAnaUID;
  targetUI;
  colordey = false;
  async ngOnInit(){
   this.showSwitch();
   window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (theEmail, theEmailID) => this.angularFunctionCalled(theEmail, theEmailID), };
   const s = this.renderer2.createElement('script');
   s.type = 'text/javascript';
   s.src = 'https://accounts.google.com/gsi/client';
   s.text = ``;
   s.setAttribute("async",'');
   s.setAttribute("defer",'');
   this.renderer2.appendChild(this._document.body, s);
   
   let prodID = '700227042414-evol173ajbq0l5qggtsorvd2hf4eptt6.apps.googleusercontent.com';
   let webID = '104220689689-h7to5351psftr88a0uu4ds6o0mnbqdn3.apps.googleusercontent.com';
   let localhostID = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
   const s2 = this.renderer2.createElement('script');
   s2.text = `function handleCredentialResponse(response) {
        
        let rez = decodeJwtResponse(response.credential);
        
        callAngularFunction(rez.email, rez.sub);
      }

      function callAngularFunction(theEmail, theEmailID) {  
        window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(theEmail, theEmailID); });  
      }  

      window.onload = function () {
        let local = 'http://localhost:4201/#/login';
        let local2 = 'http://localhost:4201/';
        let web = 'http://web.infoviewsims.com/#/login';
        let web2 = 'http://web.infoviewsims.com/';
        let googleAPI = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';

        if(window.location.href == web || window.location.href == web2) {
          googleAPI = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
        }
        else if (window.location.href !== local && window.location.href !== local2 && !window.location.href.includes('user')) {
          googleAPI = '700227042414-evol173ajbq0l5qggtsorvd2hf4eptt6.apps.googleusercontent.com';
        }

        /* global google */
        google.accounts.id.initialize({
          client_id: googleAPI,
          callback: handleCredentialResponse
        });
        google.accounts.id.renderButton(
          document.getElementById("buttonDiv"),
          { theme: "outline", size: "large" }  // customization attributes
        );
        google.accounts.id.prompt(); // also display the One Tap dialog
      }

      function decodeJwtResponse(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      }
      
      function googleLogOut(){
        let local = 'http://localhost:4201/#/login';
        let local2 = 'http://localhost:4201/';
        let web = 'http://web.infoviewsims.com/#/login';
        let web2 = 'http://web.infoviewsims.com/';
        let googleAPI = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
        
        if(window.location.href == web || window.location.href == web2) {
          googleAPI = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
        }
        else if (window.location.href !== local && window.location.href !== local2 && !window.location.href.includes('user')) {
          googleAPI = '700227042414-evol173ajbq0l5qggtsorvd2hf4eptt6.apps.googleusercontent.com';
        }

        /* global google */
        google.accounts.id.initialize({
          client_id: googleAPI,
          callback: handleCredentialResponse
        });
        google.accounts.id.renderButton(
          document.getElementById("buttonDiv"),
          { theme: "outline", size: "large" }  // customization attributes
        );
        // google.accounts.id.prompt();
      }
      `;
    this.renderer2.appendChild(this._document.body, s2);
    if (sessionStorage.getItem('splashMessage') && !sessionStorage.getItem('inIframe')) {
      
      this.triggerReset();
    }
    sessionStorage.clear();
    localStorage.removeItem('duplicateSchoolStudents');
    localStorage.removeItem('activeSchoolStudents');
    this._Activatedroute.queryParams.subscribe(params => { 
      if (params.user !== undefined) {
        sessionStorage.setItem('inIframe', 'yes');
        let str = params.person;
        if (params.school_id) {
          this.edAnaSchoolID = params.school_id;       
        }
        if (params.user_id) {
          this.edAnaUID = params.user_id;       
        }
        if (params.targetUI) {
          this.targetUI = params.targetUI;
          this.sharedDataService.targetUI = params.targetUI;
        }
        sessionStorage.setItem('login_email', params.user);
        this.loginMeIn(str);
        // this.sharedDataService.celebrate('Logging into Infoview SIMS');
      }
      if (params.session_timeout) {
        this.showMessage('Session Timeout');
        this.logginIn = true;
        this.location.replaceState('/login');
        setTimeout(() => {
          location.reload();
        }, 3000);
      }
    });
    if (sessionStorage.getItem('inIframe')) {
      this.cannotSignInOtherwise = true;
      
      
      this.sharedDataService.showSpinner();
    }
    else{
      
      this.cannotSignInOtherwise = false;
    }

    localStorage.removeItem('auth');
    localStorage.removeItem('tokenInfo');
    localStorage.removeItem('tokenInfoFull');
    await this.sharedDataService.geoFindMe();
    await this.sharedDataService.delay(6000);
    this.sharedDataService.checkedForClassrooms = false;
    this.sharedDataService.checkedForCurrencies = false;
    this.sharedDataService.checkedForStudents = false;
    this.sharedDataService.checkedForBranches = false;
    this.sharedDataService.checkedForTeachers = false;
    this.sharedDataService.checkedForBankAccounts = false;
    this.sharedDataService.checkedForCourses = false;
    this.sharedDataService.checkedForPopulation = false;
    this.sharedDataService.checkedForTerms = false;
    this.sharedDataService.checkedForExpenses = false;
    this.sharedDataService.checkedForAnalytics = false;
    this.sharedDataService.checkedForRevenue = false;
    this.sharedDataService.schoolBranches = [];
    this.sharedDataService.getSchoolCurrenciesCollection = [];
    this.sharedDataService.schoolClassrooms = [];
    this.sharedDataService.schoolBankAccounts = [];
    this.sharedDataService.schoolTeachers = [];
    this.sharedDataService.schoolCourses = [];
    this.sharedDataService.schoolEmployees = [];
    this.sharedDataService.classPopulation = [];
    this.sharedDataService.schoolPopulation = [];
    this.sharedDataService._sims = [];
    this.sharedDataService.schoolTerms = [];
    this.sharedDataService.wholeSchoolStudents = [];
    this.sharedDataService.homepageData = [];
    this.sharedDataService.getSchoolInvoiceItemsCollection = [];
    this.sharedDataService.assTypes = [];
    this.sharedDataService.assCategories = [];
    this.sharedDataService.schoolGroups = [];
    this.sharedDataService.schoolAccountTypes = [];
    this.sharedDataService.schoolMedConditions = [];
    this.sharedDataService.schoolExpenses = [];
    this.sharedDataService.schoolRevenue = [];
    this.sharedDataService.schoolAnalytics = [];
    let color = localStorage.getItem('lastSchoolColor');
    let seccolor = localStorage.getItem('lastSchoolSecColor');
    if (color !== null) {
      this.schoolColor = color;
      document.body.style.setProperty('--schpricol', color);
      seccolor !== null ? document.body.style.setProperty('--schseccol', seccolor) : document.body.style.setProperty('--schseccol', '#ffffff');
      this.colordey = this.schoolColor == '#6fa6e6' ? false : true;
    }
    else{
      this.schoolColor = '#6fa6e6';
      document.body.style.setProperty('--schpricol', this.schoolColor);
      document.body.style.setProperty('--schseccol', this.schoolColor);
    }

    // get Time Started
    let x=setInterval(()=>{
        if(window.location.href.includes("login")){
        let secondshtml=document.getElementById('secondsH')
        let minuteshtml=document.getElementById('minuteH')
        let hourshtml=document.getElementById('hourH')
  
        let d=new Date()
        let seconds=d.getSeconds() *6
        let minutes=d.getMinutes()* 6
        let hours=d.getHours() *30 + Math.round(minutes/12)
  
        secondshtml.style.transform="rotate("+seconds+"deg)"
        minuteshtml.style.transform="rotate("+minutes+"deg)"
        hourshtml.style.transform="rotate("+hours+"deg)"
  
      }else{
        clearInterval(x)
      }
      },1000)
  }

  initVars(){

  }

  quoteOfTheDay = "Na only you sabi wetin you no suppose sabi";
  private typewriter_display: string = "";
  private typewriter_text: string = "";
  typingCallback(that) {
    let total_length = that.typewriter_text.length;
    let current_length = that.typewriter_display.length;
    if (current_length < total_length) {
      that.typewriter_display += that.typewriter_text[current_length];
      setTimeout(that.typingCallback, 20, that);
    }
    else{
      document.getElementById('demo').setAttribute('style', 'font-family: inherit !important;');    
      document.getElementById('demo').setAttribute('style', 'font-weight: 400 !important;');    
      // document.getElementById('demo').setAttribute('style', 'color: var(--schcol, #c5c5c5) !important;');  
    }
  }

  quoteCategories = ['learning', 'knowledge'];
  getTodaysQuote(){
    let quoteSaved = localStorage.getItem('quoteOfTheDay');
    let fetchQuote = false;
    let day;
    let savedQuote:string = '';
    let category:string = this.quoteCategories[0];
    if (quoteSaved) {
      let parsedQuote = quoteSaved.split('|');
      day = parsedQuote[0];
      savedQuote = parsedQuote[1];
      category = parsedQuote[2] == this.quoteCategories[0] ? this.quoteCategories[1] : this.quoteCategories[0];
    }
    else{
      fetchQuote = true;
    }

    if (!fetchQuote && day !== this.sharedDataService.getTheDate()) {
      fetchQuote = true;
    }

    if (fetchQuote){
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('X-Api-Key', this.sharedDataService.quoteAPIkey);
      
      let requestOptions = new RequestOptions();
      requestOptions.headers = headers;

      this.http.get(this.sharedDataService.quoteAPIurl + category, requestOptions).subscribe(
        res => {
          let response = res.json();
          localStorage.setItem('quoteOfTheDay', this.sharedDataService.getTheDate() + '|' + response[0].quote + ' - ' + response[0].author + '|' + category);          
          this.renderQuote(response[0].quote + ' - ' + response[0].author);
        },
        err => {
          this.renderQuote('We are always happy to see you here. - InfoView Data Solutions');
        }
      );
    }
    else{
      this.renderQuote(savedQuote);
    }
  }

  renderQuote(quote){
    this.typewriter_text = quote;
    setTimeout(() => {
      this.typingCallback(this);
    }, 1000);
  }

  sayHello(thingToSay){
    this.sharedDataService.celebrate(thingToSay);
  }

  angularFunctionCalled(theEmail, theEmailID) {
    if (this.cannotSignInOtherwise) {
      return;
    }
    else{
      this.sharedDataService.celebrate('Signing In as ' + theEmail);
    }
    this.logginInGoogle = true;
    this.usernameElement.nativeElement.value = theEmail;
    this.passwordElement.nativeElement.value = '';
    
    // this.loginMeIn(theEmail);
    this.validateGoogleUser(theEmail, theEmailID);
  }

  validateGoogleUser(email, id){
    let password = id;
    let url = this.apiUrl + '/platform/login_auth?email=' + email + '&password=' + id;
    
    
    // proper
    this.http.get(url).subscribe(
      res => {
        let response = res.json();
        password = response.password;
        if (!password) {
          this.showMessage(res.json().message);        
          this.sharedDataService.celebrate(res.json().message);        
          this.logginInGoogle = false;
        } else {
          let str = email + ':' + password;
          // sessionStorage.setItem('login_email', email);
          this.sharedDataService.login_email = email;
          
          
          
          this.logginInGoogle = false;
          this.loginMeIn(str);
        }
      },
      err => {
        this.sharedDataService.celebrate('User does not exist');
        this.logginInGoogle = false;
      }
    );
  }

  ngAfterViewInit(){
    this.sharedDataService.getIP();
    if (!this.cannotSignInOtherwise) {
      setTimeout(() => {
        this.offElement.nativeElement.setAttribute('style','display: none');      
      }, 1000);   
    }
    // this.getTodaysQuote();
    // var backgrd = this.backElement.nativeElement;
    // backgrd.style.backgroundImage = "url('/../../assets/img/mc1.webp')";
    // setInterval(() => {
    //   this.changeBack();
    // }, 8000);
  }

  schoolColor = '#ffffff';
  changeBack(){
    var backgrd = this.backElement.nativeElement;
    this.images = ['/../../assets/img/mc2.webp', '/../../assets/img/mc3.webp', '/../../assets/img/mc4.webp', '/../../assets/img/mc5.webp', '/../../assets/img/mc1.webp'];
    if (this.i == 4) {
      this.i = 0;
      backgrd.style.backgroundImage = "url(" + this.images[this.i] + ")";
      this.i++
    }
    else{
      backgrd.style.backgroundImage = "url(" + this.images[this.i] + ")";
      this.i++
    }
  }

  i = 1;
  images = [];
  slideTime = 3000; // 3 seconds

  isDev = false;
  isLocal = true;
  googleApi = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
  pointingtodev = false;
  showSwitch(){
    let local = 'http://localhost:4200/#/login';
    let local2 = 'http://localhost:4200/';
    let prod = 'https://infoviewsims.com/';
    let prod2 = 'https://infoviewsims.com/#/login';
    let prod3 = 'https://www.infoviewsims.com/';
    let prod4 = 'https://www.infoviewsims.com/#/login';
    let dev = 'http://web.infoviewsims.com/';
    let dev2 = 'http://web.infoviewsims.com/#/login';
    if (window.location.href !== prod && window.location.href !== prod2 && window.location.href !== prod3 && window.location.href !== prod4 && window.location.href !== local) {
      this.isDev = true;
    }
    else{
      this.isDev = false;
    }
    if (window.location.href !== local && window.location.href !== local2) {
      this.isLocal = false;
      this.googleApi = '700227042414-evol173ajbq0l5qggtsorvd2hf4eptt6.apps.googleusercontent.com';
    }
    
    // this.isDev = true;
    this.pointingtodev = this.sharedDataService.apiUrl == this.sharedDataService.httpsDevApiUrl ? true : false;
  }

  onlineSupp(){
    open("https://docs.google.com/forms/d/e/1FAIpQLSfC7cd5jxBBuRH1S-cBNTFFwj5E7Wq6xr3fV9iNvqkTwUV3OQ/viewform", "_blank");
  }

  callUs(){
    window.open('tel:+233505302567');
  }

  pointTo(valeu){
    if (valeu == 'dev') {
      this.sharedDataService.apiUrl = this.sharedDataService.httpsDevApiUrl;
      this.apiUrl = this.sharedDataService.httpsDevApiUrl;
      this.pointingtodev = true;
    } else {
      this.sharedDataService.apiUrl = this.sharedDataService.prodApiUrl;
      this.apiUrl = this.sharedDataService.prodApiUrl;
      this.pointingtodev = false;
    }
  }

  showNew = true;
  toggleOldNew(){
    setTimeout(() => {
      this.showNew = this.showNew ? false:true;      
    }, 300);
  }

  setSimsBlue(){
    this.schoolColor = '#6fa6e6';
    localStorage.setItem('lastSchoolColor', this.schoolColor);
    this.colordey = false;
    localStorage.setItem('lastSchoolSecColor', this.schoolColor);
    document.body.style.setProperty('--schpricol', this.schoolColor);
    document.body.style.setProperty('--schseccol', this.schoolColor);
  }

  private username: any;
  private password: any;

  private usernameAndPassNotCorrect: string = "Your details are incorrect. Please try again";
  private usernameAndPassEmpty: string = "Please do not leave the username and password empty";
  private weCouldNotConnectToOurServers: string = 'We could not connect to our servers, check your internet connection :(';

  private usernameEmpty: string = "Please do not leave username empty";
  private passwordEmpty: string = "Please do not leave password empty";
  private goodToGo: string = 'Your good to go';

  private apiUrl: string = this.sharedDataService.apiUrl;
  private school_id;
  private encoded64BitUserPassString;

  private tokenInformation;
  private schoolIdInformation;

  public subMessage = 'Sign into your account';
  private selectFromMultiple = 'Please select a school to continue';

  public schoolsToSelectFrom: any = [];

  okayClicked = false;
  refuseLocation(){
    this.showLocationEnforcement = false;      
  }

  async confirmLocation(){
    this.okayClicked = true;
    await this.sharedDataService.geoFindMe();
    await this.sharedDataService.delay(6000);
    this.okayClicked = false;
    if (this.sharedDataService.positionAllowed == false) {
      this.sharedDataService.celebrate('Please Turn On Location Access for this Site on your Browser');
    }
    else{
      this.showLocationEnforcement = false;
    }
  }


  logginIn = false;
  logginInGoogle = false;
  showLocationEnforcement = false;
  async loginMeIn(viaGoogle?: string) {
    if (this.logginIn) {
      return 0;
    }
    this.logginIn = true;
    
    if (!viaGoogle) {
      if (this.sharedDataService.positionAllowed == false && this.sharedDataService.windowSize > 500) {
        await this.sharedDataService.geoFindMe();
        await this.sharedDataService.delay(6000);
        if (this.sharedDataService.positionAllowed == false) {
          this.showLocationEnforcement = true;
          this.logginIn = false;
          return;          
        }          
      }
    }

    // sessionStorage.clear();
    // this.sharedDataService.wholeSchoolStudents = [];
    // this.sharedDataService.schoolClassrooms = [];

    if (!viaGoogle) {
      const usernameValue = this.usernameElement.nativeElement.value;
      const passwordValue = this.passwordElement.nativeElement.value;
      this.sharedDataService.login_email = this.usernameElement.nativeElement.value;
      // get the tokenInformation
      const encodedUserPassString =  btoa(usernameValue + ':' + passwordValue);
      this.encoded64BitUserPassString = 'Basic ' + encodedUserPassString;      
      if(usernameValue.length !== 0 && passwordValue.length !== 0){
        // get token and school by id information
        this.getTokenInformation();
        const errorMessageParentElement = this.errorMessageParentElement.nativeElement;
        errorMessageParentElement.setAttribute('style', 'display: none');
  
        let nameSubbed = usernameValue.substring(0, usernameValue.lastIndexOf("@"))
        this.sharedDataService.created_by = nameSubbed;
      }else if(usernameValue.length > 0){
        this.logginIn = false;
        // when username is filled
        this.showMessage(this.passwordEmpty);
  
      }else if(passwordValue.length > 0){
        this.logginIn = false;
        // when password is filled
        this.showMessage(this.usernameEmpty);
  
      }else{
        this.logginIn = false;
        // when both are empty
        this.showMessage(this.usernameAndPassEmpty);
      }
    }
    else{
      const encodedUserPassString =  btoa(viaGoogle);
      this.encoded64BitUserPassString = 'Basic ' + encodedUserPassString;
      this.getTokenInformation(viaGoogle);
    }
  }

  public getTokenInformation(googleMail?:string){
    // let tokenUrl = googleMail ? this.apiUrl + '/token?detail=1&app_type=Sims_web_google' : this.apiUrl + '/token?detail=1&app_type=Sims_web';
    
    
    let tokenUrl = sessionStorage.getItem('inIframe') && this.edAnaSchoolID ? this.apiUrl + '/token_edanalytica?app_type=SIMS&user_id=' + this.edAnaUID :  this.apiUrl + '/token?detail=1&app_type=Sims_web';
    
    let requestOptions = new RequestOptions();
    requestOptions.headers = this.returnHeaders();

    this.http.get(tokenUrl, requestOptions).subscribe(
      res => {
        this.checkSchoolMultipleAndLogIn(res, googleMail); 
      },
      (msg) => {
        if(navigator.onLine !== true){
          this.logginIn = false;
          // if user could not get to it because of internet
          this.showMessage(this.weCouldNotConnectToOurServers);
        }
        else {
          this.logginIn = false;
          this.sharedDataService.closeSpinner();
          if (this.cannotSignInOtherwise) {
            this.sharedDataService.showAlert("Error", "Could Not Access SIMS",()=>{},()=>{}, 'OK', 'Close');            
          }
          // tell the user his details are wrong
          this.showMessage(msg.json().message);
        }
      }
    );

    this.showLoadingBar();
  }

  
  async checkSchoolMultipleAndLogIn(tokenInfo, googleMail?:string){
    if (!tokenInfo.json().School_Identifier && !sessionStorage.getItem('inIframe')) {
      this.hideLoadingBar();
      if (tokenInfo.json().message) {
        let msg = tokenInfo.json().message  == 'No such Person_ID or user is not active' ? 'Incorrect username or password' : tokenInfo.json().message();
        this.showMessage(msg);
      }
      else{
        this.showMessage('Unable To Authenticate User');
      }
      this.logginIn = false;
      return;
    }
    let tempAppUserSchools = [];
    if (sessionStorage.getItem('inIframe')) {
      const passwordValue = this.edAnaUID ? tokenInfo.json().Password : this.passwordElement.nativeElement.value;

      let str = tokenInfo.json().Username + ':' + passwordValue;
      str = btoa(str);
      this.encoded64BitUserPassString = 'Basic ' + str;
      this.sharedDataService.encoded64BitAuth = this.encoded64BitUserPassString;
      
      let requestOptions = new RequestOptions();
      requestOptions.headers = this.returnHeaders();

      // if (!tokenInfo.json().App_User_Schools && !tokenInfo.json().School_Identifier) {
      
      let rez = await this.sharedDataService.httpGetAsync('/school?school_id=' + this.edAnaSchoolID);
        
        const school = rez.json();
        tempAppUserSchools = rez.json();
        this.sharedDataService.schoolCache = JSON.stringify(school);
        // this.hideLoadingBar();
        // this.sharedDataService.closeSpinner();
        // 
        // this.sharedDataService.showAlert("Error", tokenInfo.json().message,()=>{},()=>{}, 'OK', 'Close');
      //   return;
      // }
    }
    let loginWrapperElement;
    let selectSchoolFromMultipleElement;
    let goBackElement;
    if (!this.cannotSignInOtherwise) {
      loginWrapperElement = this.loginWrapper.nativeElement;
      selectSchoolFromMultipleElement = this.selectSchoolFromMultiple.nativeElement;
      goBackElement = this.goBackElement.nativeElement;
    }
    this.tokenInformation = tokenInfo.json();    
    if (!this.edAnaUID) {
      if (!this.tokenInformation.Employee.length) {
        this.showMessage('No Employee Record Found');
        this.logginIn = false;
        return;
      }        
    }
    if (googleMail && !sessionStorage.getItem('inIframe')) {
      const encodedUserPassString = btoa(googleMail + ':' + this.tokenInformation.Role_Identifier + ':' + this.tokenInformation.Employee[0].School_Employee_Identifier);
      this.encoded64BitUserPassString = 'Basic ' + encodedUserPassString;
      this.sharedDataService.encoded64BitAuth = this.encoded64BitUserPassString;
      sessionStorage.setItem('loggedInWithGoogle', 'yes');
    }
    let tkn = JSON.stringify(this.tokenInformation);
    sessionStorage.setItem('tokenInfoFull',  tkn );
    localStorage.setItem('tokenInfoFull',  tkn );
    // DELETE THIS IF 
    // if (tokenInfo.json().Username == 'kitman@webschool.com') {
    //   this.tokenInformation.Role_Identifier = [{
    //     Role_Identifier: 1469,
    //     School_Identifier: 600
    //   },{
    //     Role_Identifier: 1663,
    //     School_Identifier: 626
    //   }];
    // }
    
    if (sessionStorage.getItem('inIframe')) {
      this.tokenInformation.App_User_Schools = tempAppUserSchools;
      if (this.tokenInformation.App_User_Schools.length) {
        // if (this.tokenInformation.App_User_Schools.length > 1) {
          let foundSchool = false;
          this.tokenInformation.App_User_Schools.forEach(element => {
            if (element.School_Identifier.toString() == this.edAnaSchoolID.toString()) {
              foundSchool = true;
              this.tokenInformation.School_Identifier = [element];              
              this.continueWithSchool(this.tokenInformation);              
            }
          });

          if (!foundSchool) {
            this.sharedDataService.showAlert("Error", 'Not Linked To School',()=>{},()=>{}, 'OK', 'Close');
            this.hideLoadingBar();
            this.sharedDataService.closeSpinner();
          }
        // }
        // else{
        //   this.tokenInformation.School_Identifier = [...this.tokenInformation.App_User_Schools];
        //   this.continueWithSchool(this.tokenInformation);
        // }
      } else {
        this.sharedDataService.showAlert("Error", 'Not Linked To Any School',()=>{},()=>{}, 'OK', 'Close');
        this.hideLoadingBar();
        this.sharedDataService.closeSpinner();
      }
    }
    else if(this.tokenInformation.School_Identifier.length > 1){
      // this.cannotSignInOtherwise = false;
      this.subMessage = this.selectFromMultiple;
      // push the schools for selection
      this.tokenInformation.School_Identifier.forEach( (oneSchool)=>{ this.schoolsToSelectFrom.push( oneSchool ) });
      this.hideLoadingBar();
      // hide the login wrapper
      // if (!this.cannotSignInOtherwise) {
        loginWrapperElement.setAttribute('style', 'display:none');

        //goBackElement
        goBackElement.setAttribute('style', 'display: initial');          
      // }
    }
    else {
      if (Array.isArray(this.tokenInformation.Role_Identifier)) {
        let role = this.tokenInformation.Role_Identifier.find(role => role.School_Identifier == this.tokenInformation.School_Identifier[0].School_Identifier);
        let roleName = this.tokenInformation.Role_Name.find(role => role.School_Identifier == this.tokenInformation.School_Identifier[0].School_Identifier);
        let theEmpid = this.tokenInformation.Employee.find(role => role.School_Identifier == this.tokenInformation.School_Identifier[0].School_Identifier);
        if (role) sessionStorage.setItem('role_id', role.Role_Identifier);
  
        const encodedUserPassString =  btoa(this.usernameElement.nativeElement.value + ':' + this.passwordElement.nativeElement.value + ':' + role.Role_Identifier + ':' + theEmpid.School_Employee_Identifier);
        
        this.encoded64BitUserPassString = 'Basic ' + encodedUserPassString;
        this.sharedDataService.encoded64BitAuth = this.encoded64BitUserPassString;
        this.sharedDataService.role_name = roleName.Role_Name;
  
        this.sharedDataService.showSpinner();
        let rez:any = await this.httpGetAsync('/client_application_resource?role_id=' + role.Role_Identifier);
        this.sharedDataService.closeSpinner();
        if (rez.status == 200) {
          this.sharedDataService.roles = rez.json();
          this.continueWithSchool(this.tokenInformation);
        }
        else{
          this.sharedDataService.roles = this.tokenInformation.roles;
          this.continueWithSchool(this.tokenInformation);
        }
      }
      else {
        if (this.tokenInformation.Role_Identifier) sessionStorage.setItem('role_id', this.tokenInformation.Role_Identifier);
        this.sharedDataService.roles = this.tokenInformation.roles;
        this.continueWithSchool(this.tokenInformation);
      }

      // this.sharedDataService.roles = this.tokenInformation.roles;
      // sessionStorage.setItem('role_id', this.tokenInformation.Role_Identifier);
      // this.continueWithSchool(this.tokenInformation);
    }

  }

  startLoginOperations(res){
    // set token Info
    this.tokenInformation = res;
    this.sharedDataService.tokenInformationServe  = this.tokenInformation;

    // set school Id
    this.school_id = Array.isArray(this.tokenInformation.School_Identifier) ? this.tokenInformation.School_Identifier[0].School_Identifier : this.tokenInformation.School_Identifier;

    // set get school by id url
    const schoolUrl = this.apiUrl+'/school?school_id='+this.school_id;

    // call get school by id
    this.getSchoolInfo(schoolUrl);
  }

  getSchoolInfo(schoolUrl){
    const schoolUrlFromArg = schoolUrl;

    const requestOptions = new RequestOptions();
    requestOptions.headers = this.returnHeaders();

    this.http.get(schoolUrlFromArg,requestOptions).subscribe(

      (res) => {
        this.schoolIdInformation =  res['_body'];
        this.schoolIdInformation = [this.schoolIdInformation[0]];
        this.storeInformation(this.tokenInformation, this.schoolIdInformation, this.encoded64BitUserPassString);
      } ,
      (msg) => {
        // this.showMessage('There is no school for this user')
        this.schoolIdInformation = [this.tokenInformation.School_Identifier[0]];
        this.storeInformation(this.tokenInformation, this.schoolIdInformation, this.encoded64BitUserPassString);
      }

    );
  }

  storeInformation(tokenInfo, schoolInfo, encoded64BitAuth){
    this.hideLoadingBar();

    this.sharedDataService.tokenInformationData = tokenInfo;

    let jsonifiedSchoolInfo = JSON.stringify(tokenInfo);

    localStorage.setItem('tokenInfo', jsonifiedSchoolInfo);
    sessionStorage.setItem('tokenInfo', jsonifiedSchoolInfo);


    if (tokenInfo.School_Identifier.length == 1 && !this.edAnaSchoolID) {
      let newBtoaAuth = '';
      let btoaAuth = atob(encoded64BitAuth.substring(6));
      let arrayOfbtoa = btoaAuth.split(':');
      if (arrayOfbtoa.length == 2) {
        newBtoaAuth = btoaAuth + ':' + this.tokenInformation.Role_Identifier + ':' + tokenInfo.Employee[0].School_Employee_Identifier;
        encoded64BitAuth = 'Basic ' + btoa(newBtoaAuth);
      }
    }

    if (this.edAnaSchoolID) {
      this.sharedDataService.roles = this.tokenInformation.roles;
      sessionStorage.setItem('role_id', this.tokenInformation.Role_Identifier);
    }

    localStorage.setItem('auth', encoded64BitAuth);
    this.sharedDataService.encoded64BitAuth = encoded64BitAuth;

    // store them in the service
    this.sharedDataService.tokenInformation = tokenInfo;
    this.sharedDataService.schoolInformation = tokenInfo;
    if(tokenInfo){
      if( tokenInfo.Employee){
        let empID = tokenInfo.Employee.find(emp=>emp.School_Identifier==this.school_id)
        if(empID){
          this.sharedDataService.school_emp_Id = empID.School_Employee_Identifier
        }
      }
    }

    // this.sharedDataService.schoolInformation2 = schoolInfo;
    //this.checkSchoolMultipleAndLogIn(tokenInfo);
    //this.sharedDataService.encoded64BitAuth = this.encoded64BitUserPassString;
    this.hideLoadingBar();
    this.sharedDataService.getSchoolCurrencies();
    this.sharedDataService.getSchoolTerms();
    this.logginIn = false;
    this.router.navigate(['/home']);
  }

  async httpGetAsync(url){
    const requestOptions = new RequestOptions();
    requestOptions.headers = this.returnHeaders();
    let response;
    try {
      response = await this.http.get(this.apiUrl + url, requestOptions).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async selectedSchool(schoolSelected){
    this.showLoadingBar();
    this.tokenInformation.School_Identifier = [];
    this.tokenInformation.School_Identifier.push(schoolSelected);
    
    
    if (Array.isArray(this.tokenInformation.Role_Identifier)) {
      let role = this.tokenInformation.Role_Identifier.find(role => role.School_Identifier == schoolSelected.School_Identifier);
      let roleName = this.tokenInformation.Role_Name.find(role => role.School_Identifier == schoolSelected.School_Identifier);
      let theEmpid = this.tokenInformation.Employee.find(role => role.School_Identifier == schoolSelected.School_Identifier);
      if (role) sessionStorage.setItem('role_id', role.Role_Identifier);

      const encodedUserPassString =  btoa(this.usernameElement.nativeElement.value + ':' + this.passwordElement.nativeElement.value + ':' + role.Role_Identifier + ':' + theEmpid.School_Employee_Identifier);
      
      this.encoded64BitUserPassString = 'Basic ' + encodedUserPassString;
      this.sharedDataService.encoded64BitAuth = this.encoded64BitUserPassString;
      this.sharedDataService.role_name = roleName.Role_Name;

      this.sharedDataService.showSpinner();
      let rez:any = await this.httpGetAsync('/client_application_resource?role_id=' + role.Role_Identifier);
      this.sharedDataService.closeSpinner();
      if (rez.status == 200) {
        this.sharedDataService.roles = rez.json();
      }
      else{
        this.sharedDataService.roles = this.tokenInformation.roles;
      }
    }
    else {
      this.sharedDataService.roles = this.tokenInformation.roles;
      sessionStorage.setItem('role_id', this.tokenInformation.Role_Identifier);
    }
    
    this.continueWithSchool(this.tokenInformation);
  }

  continueWithSchool(schoolSelected){
    this.startLoginOperations(schoolSelected);
  }

  goBackToLoginFace(){
    // reload current page
    if (sessionStorage.getItem('inIframe')) {
      this.cannotSignInOtherwise = true;
    }
    location.reload();
  }

  showMessage(errorMessage){
    const errorMessageParentElement = this.errorMessageParentElement.nativeElement;
    const errorMessageElement = this.errorMessage.nativeElement;

    errorMessageParentElement.setAttribute('style', 'display: initial');
    errorMessageElement.innerText = errorMessage == undefined ? 'Could not connect to server' : errorMessage;

    this.hideLoadingBar();
  }

  returnHeaders(){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', this.encoded64BitUserPassString);
    headers.append('x-location', this.sharedDataService.locationSub);
    headers.append('x-device-info', this.sharedDataService.getBrowserName());

    return headers;
  }

  viewPassword(val) {
    //var x = document.getElementById("pass");
    var x = this.passwordElement.nativeElement;
    var on = this.onElement.nativeElement;
    var off = this.offElement.nativeElement;
    if (val == 1) {
      on.setAttribute('style','color: gray; cursor: pointer; margin-left: -25px; display: none');
      off.setAttribute('style','color: gray; cursor: pointer; margin-left: -25px; display: initial');
    } else {
      off.setAttribute('style','color: gray; cursor: pointer; margin-left: -25px; display: none');
      on.setAttribute('style','color: gray; cursor: pointer; margin-left: -25px; display: initial');
    }
    if (x.type == 'password') {
      x.setAttribute('type','text');
    } else {
      x.setAttribute('type','password');
    }
  }

}






// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/session/loginone/loginone.component.ts